import React from 'react';
import { Form } from 'src/components/Antd';
import Co from 'src/constrains/AdvancedFilters/Collapse';
import { OrderAmount } from 'src/constrains/AdvancedFilters/Components';
import { EType } from 'src/constrains/AdvancedFilters/Components/CommonAmount';
import { EOrderStatus } from 'src/constrains/AdvancedFilters/Components/OrderAmount';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;
// // import { get } from 'lodash';
//import { formGetValue } from 'src/tools/helper';

const _OrderNumber = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    rootName,
    form,
    defaultState,
    nameType,
    nameValue,
    nameRange,
    selectName,
    ...rest
  } = props;
  const handleOnReset = () => {
    form.setFieldsValue(defaultState);
  };
  return (
    <Item
      noStyle
      shouldUpdate={(p, c) => {
        const touched = form.isFieldTouched(rootName);
        return touched; //|| cv !== pv;
      }}>
      {(f) => {
        const { getFieldValue } = f;
        const type = getFieldValue(selectName);
        const handleOnClose = () => {
          form
            .validateFields([nameType, nameValue, nameRange])
            .then(() => {
              //console.log('没错');
            })
            .catch((r) => {
              handleOnReset();
            });
        };

        const _p =
          {
            [EOrderStatus.ALL]: getI18n(
              'customerList.orderNumber.numberofallorder(s)',
            ),
          }[type] || type;

        const hasData = !!type;

        const prefix = {
          [EType.EQUALS]: getI18n('customerList.totalOrderAmount.eType.EQUALS'),
          [EType.IN_BETWEEN]: getI18n(
            'customerList.totalOrderAmount.eType.IN_BETWEEN',
          ),
          [EType.LARGER_THAN]: getI18n(
            'customerList.totalOrderAmount.eType.LARGER_THAN',
          ),
          [EType.SMALLER_THAN]: getI18n(
            'customerList.totalOrderAmount.eType.SMALLER_THAN',
          ),
        };
        const textGenerator = () => {
          const type = getFieldValue(nameType);

          if (hasData) {
            if (type === EType.IN_BETWEEN) {
              const value = getFieldValue(nameRange);
              const from = value.from;
              const to = value.to;
              if (typeof from === 'number' && typeof to === 'number') {
                return `${_p} ${prefix[type]} ${from} ${getI18n(
                  'general.and',
                )} ${to}`;
              }
            } else {
              const value = getFieldValue(nameValue);
              if (typeof value === 'number') {
                return `${_p} ${prefix[type]} ${value}`;
              }
            }
          }
          return '';
        };
        return (
          <Co
            header={
              <div>{getI18n('customerTag.orderDate.numberoforders')}</div>
            }
            displayText={textGenerator()}
            hasData={hasData}
            onClose={handleOnClose}
            onClear={handleOnReset}>
            <OrderAmount
              {...rest}
              nameValue={nameValue}
              nameRange={nameRange}
              nameType={nameType}
              selectName={selectName}
            />
          </Co>
        );
      }}
    </Item>
  );
};
export default _OrderNumber;
